import { render, staticRenderFns } from "./DatasetDetailView.vue?vue&type=template&id=42129f92&"
import script from "./DatasetDetailView.vue?vue&type=script&lang=js&"
export * from "./DatasetDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports